import React, { useMemo } from 'react';

import PropTypes from 'prop-types';
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
} from 'recharts';

import ChartCard from '~/components/ChartCard';
import LocaleMessage from '~/components/LocaleMessage';

import { ChatCardContainer } from '../../../Dashboard/styles';
import { buildEfficiencySeries } from './EfficiencyUtils';

const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
        return (
            <div className="jr-card p-3" style={{ background: '#fff' }}>
                <p className="mb-1">
                    <strong>{label}</strong>
                </p>
                <p className="mb-0" style={{ color: payload[0].color }}>
                    <LocaleMessage msg="page.robots.cleaning_report.metrics.efficiency" />
                    : {payload[0].value}
                </p>
            </div>
        );
    }
    return null;
};

export default function EfficiencyGraphCard({
    list,
    color,
    localeCode,
    periodDates,
}) {
    const data = useMemo(
        () => buildEfficiencySeries(list, localeCode, periodDates),
        [list, localeCode, periodDates]
    );

    if (!data || data.length === 0) return null;

    return (
        <div className="row card-row">
            <div className="col-12 dash-card mb-5">
                <ChatCardContainer>
                    <ChartCard
                        className="animated slideInFromLeft animation-duration-3"
                        title={
                            <LocaleMessage msg="page.robots.cleaning_report.metrics.efficiency.title" />
                        }
                        desc={
                            <LocaleMessage msg="page.robots.cleaning_report.metrics.efficiency.description" />
                        }
                        value=""
                    >
                        <div className="row mt-4">
                            <div className="col-12 mb-3 area-chart-container">
                                <ResponsiveContainer
                                    className="card-img-bottom overflow-hidden animated slideInFromLeft animation-duration-5"
                                    width="100%"
                                    height={320}
                                >
                                    <LineChart
                                        data={data}
                                        margin={{ left: -10, right: 10 }}
                                    >
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis dataKey="date" />
                                        <YAxis />
                                        <Tooltip content={<CustomTooltip />} />
                                        <Line
                                            type="monotone"
                                            dataKey="efficiency"
                                            stroke={color}
                                            strokeWidth={3}
                                            dot={{ r: 4, fill: color }}
                                            activeDot={{ r: 6 }}
                                        />
                                    </LineChart>
                                </ResponsiveContainer>
                            </div>
                        </div>
                    </ChartCard>
                </ChatCardContainer>
            </div>
        </div>
    );
}

EfficiencyGraphCard.propTypes = {
    list: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    color: PropTypes.string.isRequired,
    localeCode: PropTypes.string,
    periodDates: PropTypes.shape({
        startDate: PropTypes.string,
        endDate: PropTypes.string,
    }),
};

EfficiencyGraphCard.defaultProps = {
    localeCode: 'pt_BR',
    periodDates: null,
};
